import Vue from 'vue';

export default class HttpException {
  errorData: any;
  constructor(errorData: any) {
    this.errorData = errorData;
  }
  static alertError(error: any, info: any) {
    const { errorData } = error;
    let messages = 'Oops, something went wrong. Please reload page';
    if (errorData.code === 4001) {
      messages = "You've rejected this transaction";
      if (errorData.useOffChain) {
        messages =
          'You have rejected this transaction. Check your transactions in Pending';
      }
    } else {
      console.error('transactionError', error);
      console.error('error in', info);
    }
    Vue.prototype.$dialog.notify.error(messages);
  }
}
